export default {
  name: "CircleLoadingIndicator",
  props: {},
  data: function () {
    return {
      windowHeight: window.innerHeight,
    };
  },
  computed: {
    height: function () {
      return `height:${(this.windowHeight - 61 - 48 ) / 2}px;`;
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight
    }
  }
};
